import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class PublisherService {
static publisherCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/publisher/create",
        data: values,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static publisherDetailsSearch = async (rowsPerPage, page, searchTerm) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/publisher/admin/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let publisherDetail = response.data.data;
      return publisherDetail;
    } catch (err) {
      throw err;
    }
  };

  static publisherDetailsID = async (publisherID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/publisher/admin/" + publisherID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let publisherDetailID = response.data.data;

      return publisherDetailID;
    } catch (err) {
      throw err;
    }
  };

  static publisherDelete = async (publisherID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/publisher/admin/" + publisherID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static publisherUpdate = async (publisherID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/publisher/" + publisherID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
